import type { QuestionnaireRevisionContext } from '@gcv/shared';

export const getLatestRevisionNote = (
  history: QuestionnaireRevisionContext[] | undefined
): string | undefined => {
  if (!history?.length) return undefined;
  const latest = history.reduce(
    (acc, entry) => (entry.revision_number > acc.revision_number ? entry : acc),
    history[0]
  );
  return latest.note;
};
